import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/terms-of-service.md?raw';

export default function TermsScreen() {
  return <LegalDoc markdown={markdown} title="Terms of Service" />;
}
